import React from "react"
import { IconContainer } from "./style"

interface IProps {
  children: React.ReactNode
  selected: boolean
  onClick: () => void
}

export const SelectButton = ({children, selected, onClick}: IProps) => (
  <IconContainer
    selected={selected}
    onClick={onClick}
  >  
    {children} 
  </IconContainer>
)